import React from "react";
import config from "../../config/config";
import "../../css/orders.css";
import { Icon, Card } from "@shopify/polaris";
import CSVReader from "react-csv-reader";
import { PageDownMajor } from "@shopify/polaris-icons";
import { CSVLink } from "react-csv";
import { Row, Col, Progress } from "reactstrap";
import callApi from "../../utils/apiCaller";

import Swal from "sweetalert2";
export class UploadTrackingNumber extends React.Component {
	state = {
		showLoadingPage: false,
		dataCSV: [],
		currentOrder: 0,
		totalOrder: 0,
		loadingValue: 0,
	};

	showLoadingPage = () => {
		this.setState({ showLoadingPage: true });
	};

	hideLoadingPage = () => {
		this.setState({ showLoadingPage: false });
	};

	handleFileCsvUpload = async (data) => {
		console.log(data);
		if (data.length === 0) {
			Swal.fire({
				icon: "warning",
				title: "The uploaded file is not in the correct format",
				showCloseButton: true,
				showConfirmButton: false,
			});
		} else {
			if (data[0].order_id == undefined) {
				{
					Swal.fire({
						icon: "warning",
						title: "File upload without Order ID title",
						showCloseButton: true,
						showConfirmButton: false,
					});
				}
			} else if (data[0].tracking_number == undefined) {
				{
					Swal.fire({
						icon: "warning",
						title: "File upload without Tracking Number title",
						showCloseButton: true,
						showConfirmButton: false,
					});
				}
			} else if (data[0].tracking_carrier == undefined) {
				{
					Swal.fire({
						icon: "warning",
						title: "File upload without Tracking Company title",
						showCloseButton: true,
						showConfirmButton: false,
					});
				}
			} else {
				let count = data.length;
				var pages = Math.ceil(count / 50);
				this.setState({ totalOrder: count });
				this.showLoadingPage();
				for (var i = 0; i < pages; i++) {
					let listSave = data.slice(i * 50, i * 50 + 50);
					if (i === pages - 1) {
						await this.uploadOrderCSV(listSave, "last");
					} else {
						var loadingValue = Math.ceil((i / pages) * 100);
						this.setState({ loadingValue: loadingValue });
						await this.uploadOrderCSV(listSave, "process");
					}
				}
			}
		}
	};

	uploadOrderCSV = async (data, status) => {
		let formData = new FormData();
		formData.append("data", JSON.stringify(data));
		formData.append("shop", config.shop);
		formData.append("status", status);
		formData.append("action", "handleFileTrackingUpload");
		callApi("post", formData).then((res) => {
			if (status === "last") {
				this.hideLoadingPage();
				if (res.data.state === 1) {
					this.props.updateListOrder(res.data.listOrders);
					Swal.fire({
						icon: "success",
						title: "Successfully",
						text: res.data.msg,
						showCloseButton: false,
						showConfirmButton: false,
						timer: 3000,
					});
				} else {
					Swal.fire({
						icon: "warning",
						title: res.data.msg,
						showCancelButton: true,
						showConfirmButton: true,
					});
				}
			} else {
				let currentOrder = this.state.currentOrder + 100;
				this.setState({ currentOrder: currentOrder });
			}
		});
	};

	render() {
		const papaparseOptions = {
			header: true,
			dynamicTyping: true,
			skipEmptyLines: true,
			transformHeader: (header) =>
				header.toLowerCase().replace(/\W/g, "_"),
		};

		const headers = [
			{ label: "Order ID", key: "order_id" },
			{ label: "Tracking Number", key: "tracking_number" },
			{ label: "Tracking Carrier", key: "tracking_company" },
		];
		return (
			<Row style={{ marginTop: "30px" }}>
				<Col md={12}>
					<Card sectioned title="Upload Tracking Number By CSV">
						<div
							style={{
								position: "absolute",
								top: "4px",
								right: "20px",
							}}
						>
							<CSVLink
								data={this.state.dataCSV}
								filename={"listOrders_" + Date.now() + ".csv"}
								className="Polaris-Button Polaris-Button--newDesignLanguage"
								headers={headers}
							>
								<Icon source={PageDownMajor} />
								<span className="ml-2">Download Template</span>
							</CSVLink>
						</div>
						<div className="text-center">
							<CSVReader
								cssClass="react-csv-input"
								label="Download the template and enter the information, then upload the file. You can use this feature to get your last mile tracking number."
								onFileLoaded={this.handleFileCsvUpload}
								parserOptions={papaparseOptions}
								onError={() => console.log("error")}
							/>
						</div>
					</Card>
				</Col>
				{this.state.showLoadingPage ? (
					<div id="i_loading_page">
						<div
							className="loading_page_content"
							style={{ textAlign: "center" }}
						>
							<img
								src="https://linh.omegatheme.com/dev-better-search/admin/images/loading_cart.gif"
								alt="loading"
							/>
							<p className="mb-4">
								{" "}
								Uploading order list:{" "}
								<b>
									{this.state.currentOrder} /{" "}
									{this.state.totalOrder}
								</b>{" "}
								Orders
							</p>

							<Progress
								animated
								style={{
									height: "20px",
									margin: "auto",
									width: "75%",
								}}
								color="info"
								value={this.state.loadingValue}
								max="100"
							></Progress>
						</div>
					</div>
				) : null}
			</Row>
		);
	}
}
